import { Component, ChangeDetectionStrategy } from '@angular/core';
import { QuestionComponent } from '../abstract/question.component';

@Component({
  selector: 'question-afterschool',
  templateUrl: './question-afterschool.component.html',
  styleUrls: ['./question-afterschool.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuestionAfterschoolComponent extends QuestionComponent {}
